import { render } from "./index.vue?vue&type=template&id=78a635c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=78a635c0&lang=less&scoped=true"

import exportComponent from "/Users/summer/Desktop/code/study_mp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a635c0"]])

export default __exports__